module.exports = __webpack_public_path__ + "img/home_page_power_pose.67dabe4d.webp";